export default "__VITE_ASSET__C2reteb4__"